// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./Context/AuthContext";
import { SubscriptionProvider } from "./Context/SubscriptionContext";
import { ProtectedRoute, PublicRoute } from "./Common/ProtectedRoute";

// Authentication Components
import Login from "./pages/Authentication/Login";
import Signup from "./pages/Authentication/Signup";
import ForgotPassword from "./pages/Authentication/ForgotPassword";
import ResetPassword from "./pages/Authentication/ResetPassword";
import UserProfileSetup from "./pages/UserProfile/UserProfileSetup";
import InviteLogin from "./pages/Authentication/InviteLogin";

// Dashboard Component
import Dashboard from "./pages/Dashboard/Dashboard";

// HR Pages
import EmployeeForm from "./pages/hr/EmployeeForm";
import EmployeeDashboard from "./pages/hr/EmployeeDashboard";
import EmployeeDetails from "./pages/hr/EmployeeDetails";

// Landing Page Component (Second Project)
import LandingPage from "./pages/LandingPage";

function App() {
  return (
    <AuthProvider>
      <SubscriptionProvider>
        <Router>
          <Routes>
            {/* Landing Page Route (Second Project) */}
            <Route path="/" element={<LandingPage />} />

            {/* Public Routes - redirect to dashboard if already logged in */}
            <Route
              path="/login"
              element={
                <PublicRoute>
                  <Login />
                </PublicRoute>
              }
            />
            <Route
              path="/signup"
              element={
                <PublicRoute>
                  <Signup />
                </PublicRoute>
              }
            /> 
            <Route
              path="/forgot-password"
              element={
                <PublicRoute>
                  <ForgotPassword />
                </PublicRoute>
              }
            /> 
            <Route
              path="/reset-password"
              element={
                <ProtectedRoute>
                  <ResetPassword />
                </ProtectedRoute>
              }
            /> 

            {/* Invite-only login route (temporary, pre-launch only) */}
            <Route
              path="/invite-login"
              element={
                <PublicRoute>
                  <InviteLogin />
                </PublicRoute>
              }
            />

            {/* Protected Routes - require authentication */}
            <Route
              path="/dashboard/*"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <UserProfileSetup />
                </ProtectedRoute>
              }
            />

            {/* HR Routes (separate from dashboard) */}
            <Route
              path="/hr/employees"
              element={
                <ProtectedRoute>
                  <EmployeeDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/hr/employees/new"
              element={
                <ProtectedRoute>
                  <EmployeeForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/hr/employees/:id"
              element={
                <ProtectedRoute>
                  <EmployeeDetails />
                </ProtectedRoute>
              }
            />

            {/* Redirect unknown routes to login */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </SubscriptionProvider>
    </AuthProvider>
  );
}

export default App;